export function isPreview(props) {
    return props.mode === 'preview';
}
